import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { GetMedication } from "../../../StateManagement/Reducers/DashboardState";
import { GetList } from "../../../StateManagement/Reducers/HealthProfileState";

import { Div, PageTitle, Button, Image, Text } from "../../StyledComponents";
import { IoMdArrowForward } from "react-icons/io";
import pillIcon from "../../../Assets/images/pill_Icon.png";
import moment from "moment";

const Medication = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("problems");

  const MedicationDetails = useSelector((state) => state.Dashboard.Medication);
  const ProfileList = useSelector((state) => state.HealthProfile.List);

  useEffect(() => {
    if (activeTab === "medication") {
      dispatch(GetMedication("medication"));
    } else if (activeTab === "problems") {
      dispatch(GetList("medical_problem"));
    } else if (activeTab === "allergies") {
      dispatch(GetList("allergy"));
    } else if (activeTab === "lab") {
      dispatch(GetList("lab"));
    }
  }, [activeTab, dispatch]);

  const data = activeTab === "medication" ? MedicationDetails : ProfileList;

  const formatDate = (dateString) => {
    if (!dateString || (typeof dateString === "string" && dateString.startsWith("0000-00-00"))) {
      return "-";
    }
    const m = moment(dateString);
    return m.isValid() ? m.format("MM-DD-YYYY hh:mm A") : "-";
  };

  const headerTitle =
    activeTab === "medication"
      ? "Medication"
      : activeTab === "problems"
        ? "Problems"
        : activeTab === "allergies"
          ? "Allergies"
          : "Lab";

  return (
    <Div
      width="100%"
      minHeight="353px"
      backColor="#ffffff"
      padding="20px"
      borderRadius="8px"
      border="1px solid #d8e0f0"
      gridArea="Medication"
    >
      <PageTitle fontSize="24px" marginBottom="10px">
        Health Profile
      </PageTitle>

      <Div
        display="flex"
        alignItems="center"
        borderBottom="1px solid #E5E7EB"
        paddingBottom="8px"
        marginBottom="8px"
      >
        <Div display="flex">
          {["problems", "allergies", "lab", "medication"].map((tab) => (
            <Text
              key={tab}
              marginRight="28px"
              fontSize="14px"
              style={{
                cursor: "pointer",
                color: activeTab === tab ? "#407BFF" : "#667085",
                fontWeight: activeTab === tab ? "600" : "400",
                borderBottom: activeTab === tab ? "2px solid #407BFF" : "none",
                paddingBottom: "8px",
              }}
              onClick={() => setActiveTab(tab)}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </Text>
          ))}
        </Div>

        <Button
          background="none"
          marginLeft="auto"
          onClick={() =>
            navigate("/HealthProfile", {
              state: {
                type: {
                  type:
                    activeTab === "problems"
                      ? "medical_problem"
                      : activeTab === "allergies"
                        ? "allergy"
                        : activeTab === "lab"
                          ? "lab"
                          : "medication",
                },
              },
            })
          }
        >
          <Text color="#407BFF" fontWeight="600">
            View All →
          </Text>
        </Button>
      </Div>

      <Div
        display="flex"
        alignItems="center"
        background="#F1F5F8"
        padding="12px 18px"
        borderRadius="6px"
        marginBottom="10px"
      >
        <Text
          width="40%"
          fontWeight="600"
          color="#407BFF"
          fontSize="14px"
          textAlign="left"
        >
          {headerTitle}
        </Text>

        <Text
          width="35%"
          fontWeight="600"
          color="#407BFF"
          fontSize="14px"
          textAlign="left"
          justifyContent="flex-start"
        >
          Time Diagnosed
        </Text>

        <Text
          width="25%"
          fontWeight="600"
          color="#407BFF"
          fontSize="14px"
          textAlign="left"
        >
          Provider
        </Text>
      </Div>

      {data && data.length > 0 ? (
        data.slice(0, 4).map((item, index) => (
          <Div
            key={index}
            display="flex"
            alignItems="center"
            padding="14px 18px"
            borderBottom="1px solid #F2F4F7"
          >
            <Div width="40%" display="flex" alignItems="center">
              {activeTab === "medication" && (
                <Div
                  width="26px"
                  height="26px"
                  borderRadius="50%"
                  background="#EEF2FF"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  marginRight="6px"
                >
                  <Image src={pillIcon} width="14px" height="14px" />
                </Div>
              )}

              <Text
                fontWeight="500"
                color="#344054"
                fontSize="14px"
                textAlign="left"
              >
                {item.title}
              </Text>
            </Div>

            <Text width="35%" textAlign="left" color="#667085" fontSize="14px">
              {formatDate(
                activeTab === "allergies"
                  ? item.dateonly
                  : activeTab === "medication"
                    ? item.moddate
                    : item.date,
              )}
            </Text>

            <Div
              width="25%"
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
            >
              <Div
                width="28px"
                height="28px"
                minWidth="28px"
                borderRadius="50%"
                background="#E5E7EB"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize="12px"
                fontWeight="600"
                color="#344054"
                marginRight="2px"
              >
                {(item.providerName || item.provider)?.charAt(0) || "P"}
              </Div>

              <Text color="#344054" fontSize="14px" margin="0">
                {(item.providerName || item.provider || "-").replace(/,/g, " ")}
              </Text>
            </Div>
          </Div>
        ))
      ) : (
        <Div
          padding="40px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Text color="#98A2B3">No Data Found</Text>
        </Div>
      )}
    </Div>
  );
};

export default Medication;
